/**
 * Zustand ストアの非同期アクション共通ヘルパー
 * loading/error 状態の管理を一元化する
 *
 * @param set Zustand の set 関数
 * @param action 実行する非同期アクション
 * @param fallbackMessage エラーメッセージが取得できない場合のフォールバック文字列
 * @returns アクションの戻り値。エラー時は undefined
 */
export async function withLoading<T>(
  set: (partial: Record<string, unknown>) => void,
  action: () => Promise<T>,
  fallbackMessage = 'エラーが発生しました'
): Promise<T | undefined> {
  set({ loading: true, error: null });
  try {
    const result = await action();
    set({ loading: false });
    return result;
  } catch (error) {
    const msg = error instanceof Error ? error.message : fallbackMessage;
    set({ error: msg, loading: false });
    return undefined;
  }
}
